/**
 * Hand-rolled smooth in-page scroll with history hash update.
 *
 * Neither CSS scroll-behavior:smooth nor scrollIntoView({behavior:"smooth"})
 * animates on some embedded Chromium builds (observed: instant jump with
 * both), so the animation is done with rAF — honoring reduced-motion.
 *
 * Used by the site header's in-page links and by the homepage hero
 * CTA/down-arrow, which target the same sections.
 */
export function smoothScrollToHash(e: React.MouseEvent<HTMLAnchorElement>, hash: string) {
  e.preventDefault();
  const el = document.querySelector(hash);
  if (!el) return;
  history.replaceState(null, '', hash);
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced) {
    el.scrollIntoView();
    return;
  }
  const targetY = el.getBoundingClientRect().top + window.scrollY;
  const startY = window.scrollY;
  const distance = targetY - startY;
  const duration = Math.min(900, Math.max(350, Math.abs(distance) * 0.6));
  const start = performance.now();
  const easeInOut = (t: number) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);
  const tick = (now: number) => {
    const t = Math.min(1, (now - start) / duration);
    window.scrollTo(0, startY + distance * easeInOut(t));
    if (t < 1) requestAnimationFrame(tick);
  };
  requestAnimationFrame(tick);
}
